import { http } from "@/http/http.js";
export default {
  //图形验证码
  getCode(params) {
    return http.get("/web/login/getCode", params, { responseType: "blob" });
  },
  //账号密码登录
  loginByAccount(params) {
    return http.post("/web/login/loginByAccount", params);
  },
  //查询首页快捷菜单
  queryHomeMenuInfo(params) {
    return http.post("/web/homeManage/queryHomeMenuInfo", params);
  },
};
